import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CreateApiTokenResponseData, DeleteApiTokenResponseData } from "schema"
import { apiTokensQuery } from "../lib/apiTokensQuery"

export const useDeleteApiTokenMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await axios.delete(`/apiTokens/${id}`)
      return data.data as CreateApiTokenResponseData
    },
    onSuccess: (data: DeleteApiTokenResponseData) => {
      const queryKey = apiTokensQuery().queryKey
      queryClient.setQueryData(queryKey, (oldData) => {
        if (!oldData) return
        return oldData.filter((invite) => invite.id !== data.id)
      })
    },
  })
}
